// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonBack_button__3q4-H","arrowLeft":"ButtonBack_arrowLeft__2NseD"};